import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import '../../../scss/_placeholder.scss';
import MultistepSelectFormAdapter from '../common/MultistepSelectFormAdapter';
import { messages } from '../common/Translations';

class CompanyKeywords extends Component {

    setCustomInputRef(ref) {
        this.customInputRef = ref;
    }

    reset() {
        this.customInputRef.value = '';
    }

    applyTyping(setCustomValue, e) {
        setCustomValue({ name: e.target.value, custom: true });
    }

    revokeTyping(setCustomValue, e) {
        if (!e.target.value) {
            setCustomValue(null, false);
        }
    }

    renderInputForCustomValues(setCustomValue) {
        if(this.props.input.value.length >= this.props.maxCount) {
            return null;
        }

        return (
            <div className="row">
                <div className="col">
                    <input
                        type="text"
                        className="form-control react-select-placeholder"
                        placeholder={'Tilføj et tag eller søgeord'}
                        //@TODO Check input onKeyDown={}
                        //@TODO Check input onPaste={}
                        onKeyUp={this.applyTyping.bind(this, setCustomValue)}
                        onInput={this.revokeTyping.bind(this, setCustomValue)}
                        ref={this.setCustomInputRef.bind(this)}
                    />
                </div>
            </div>
        );
    }

    renderLabel() {
        return (
            <b>{this.props.intl.formatMessage(messages.keywordsDescription)}</b>
        );
    }

    render() {

        return (
            <MultistepSelectFormAdapter
                {...this.props}
                onReset={this.reset.bind(this)}
                onConfirm={this.reset.bind(this)}
                confirmBtnRootMsg={messages.multistepSelectButtonSelectionPlaceholder}
                confirmBtnSubMsg={messages.companyFormKeywordsConfirmBtnTextSubItem}
                renderLabel={this.renderLabel.bind(this)}
            >
                {
                    (selects, selection, buttons, setCustomValue) => {
                        return (
                            <div>
                                {selection}
                                <div className="CompanyKeywords-input">{this.renderInputForCustomValues(setCustomValue)}</div>
                                <div className="CompanyKeywords-input">{selects}</div>
                                {buttons}
                            </div>
                        );
                    }
                }

            </MultistepSelectFormAdapter>
        );
    }
}

export default injectIntl(CompanyKeywords);


// WEBPACK FOOTER //
// ./web/src/components/company/CompanyKeywords.jsx